import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Typography } from '@material-ui/core';

import { getHighlight } from '../apiQueries';
import { Period } from '../../../utils/types';
import { HighlightDetails } from '../HighlightDetails';

const SourceHighlight: React.FC<SourceHighlightProps> = (props) => {
	const { id, sport, editorialPeriodPlayIds, onPeriodRowPick } = props;

	const { loading, error, data } = useQuery(getHighlight, {
		variables: { id },
		fetchPolicy: 'no-cache'
	});

	if (loading) return <Typography>Loading...</Typography>;
	if (error) return <Typography>Error loading data from the server</Typography>;
	if (!data?.getHighlight) return <Typography>No highlight found</Typography>;

	const { available, availableTime, game, gameId, periods, publishTime, type, videoAssets } = data.getHighlight;

	return (
		<HighlightDetails
			title='Source Highlight'
			compact
			available={available}
			availableTime={availableTime}
			game={game}
			gameId={gameId}
			height={640} //in px because video player height is in px
			id={id}
			onPeriodRowPick={onPeriodRowPick}
			periods={periods}
			publishTime={publishTime}
			type={type}
			videoAssets={videoAssets}
			sport={sport}
			hidePeriodDetails={true}
			editorialPeriodPlayIds={editorialPeriodPlayIds ?? null}
		/>
	);
};

type SourceHighlightProps = {
	id: string;
	sport?: string | null;
	editorialPeriodPlayIds?: string[];
	onPeriodRowPick: (event: unknown, data: Period | Period[]) => void;
};

export default SourceHighlight;
